import throttle from 'lodash/throttle';
import { trackScreenVisibilityChange, trackScrollToBottomOfMessagesEvent } from '../analytics/screenEventAnalytics';

const SCROLL_THROTTLE = 5000;

let hidden, visibilityChange;
// Seee https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
export const initializeVisibilityListener = () => {
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  window.document.addEventListener(visibilityChange, _handleVisibilityChange, false);
};

export const removeVisibilityListener = () => {
  window.document.removeEventListener(visibilityChange, _handleVisibilityChange, false);
};

const _handleVisibilityChange = () => {
  const isHidden = !!document[hidden];
  trackScreenVisibilityChange(isHidden);
};

export const _getMessageListContainer = () => document.getElementById('messages-wrapper');

// only track a scroll to the bottom at most once per 5 seconds
export const _trackScrollToBottomOfMessagesEventWithThrottle = throttle(
  trackScrollToBottomOfMessagesEvent,
  SCROLL_THROTTLE
);
